import api from "../api/axios";

/* ---------- AUTH ---------- */
export const loginUser = (data) => api.post("api/users/login", data);

/* ---------- USERS ---------- */
export const getUsers = () => api.get("api/users");

export const createUser = (data) => api.post("api/users/create", data);

// services/userService.js
export const updateUser = (id, payload) => api.put(`api/users/${id}`, payload);
